/**
 * Zod's default messages are written for whoever wrote the schema, not for
 * whoever is filling in the form: a blank required field read "Too small:
 * expected string to have >=1 characters". Say it the way the person typing
 * would say it, for every field at once.
 */
import * as z from "zod";

import i18n from "@/lib/i18n";

z.config({
  customError: (issue) =>
    issue.input === undefined || issue.input === null || issue.input === ""
      ? i18n.t("validation.required")
      : i18n.t("validation.invalid"),
});
